import Control from '../1. Core/Control';
import DataTable from '../1. Core/Controls/DataTable/DataTable';
import TopAppBar from '../1. Core/Controls/TopAppBar/TopAppBar';
import Delegate from '../1. Core/Delegate';
import './FantasyList.scss';
import {DistributionPoint, FantasyInfo, FantasyRateRow, FantasyStatus, UserCard} from './types';
import AddFantasyDialog from "./AddFantasyDialog";
import IconToggleButton from "../1. Core/Controls/IconToggleButton/IconToggleButton";
import NP from "../1. Core/NP";
import {ServerAPI} from "../1. Core/ServerAPI";
import ChooseTeamFantasyDialog from "./ChooseTeamFantasyDialog";
import ListItem from "../1. Core/Controls/ListBox/ListItem";
import Menu from "../1. Core/Controls/Menu/Menu";
import FantasyFilterPanel from "./FantasyFilterPanel";
import Dialog, {DialogCloseEventArgs} from "../1. Core/Controls/Dialog/Dialog";
import Label from "../1. Core/Controls/Label/Label";
import {escapeHTML} from "../1. Core/util-fun";
import MetaLevelsListDialog from "./MetaLevelsListDialog";
import {IBattle} from "../10. Battle/types";
import TextField from "../1. Core/Controls/TextField/TextField";
import Select from "../1. Core/Controls/Select/Select";
import Button from "../1. Core/Controls/Button/Button";


interface UserRating {
    Name: string,
    Points: number,
    Level: number,
    DPoints: DistributionPoint[],
    Id: number,
    Index: number
    UserGroup: any
}


export default class FantasyList extends Control {
    private _topAppBar: TopAppBar;
    private EvShowPageModeClick: Delegate;
    private _filtersPanel: FantasyFilterPanel;
    private _dataTable: DataTable;
    private _Offset: number;
    private _Count: number;
    private _dataWithFiltersNode: HTMLElement;

    constructor(settings: object) {
        super(settings);
        this._render();
    }

    _initFields(settings: object) {
        this.EvShowPageModeClick = new Delegate();
        super._initFields(settings);
    }

    _render() {
        this.np_render();
        this.addClass('');

        this._Offset = 0;
        this._Count = 0;

        this._topAppBar = new TopAppBar({
            Class: 'top-app-bar--no-shadow top-app-bar--light library-box-list__app-bar',
            Caption: 'Fantasy',
            ParentNode: this._root,
            ShowSearchButton: false,
            MainButton: {
                FontImage: NP.FontImages.menu,
                EvClick: () => this.EvShowPageModeClick.fire(this)
            },
            RightItems: NP.getCurrentUser().isBDAdmin() ? [
                new IconToggleButton({
                    FontImage: NP.FontImages.add,
                    EvClick: () => {
                        new AddFantasyDialog({EvChanged: () => this.refreshList()}).show();
                    }
                }),
                new IconToggleButton({
                    ToolTip: 'User levels',
                    FontImage: NP.FontImages.info,
                    EvClick: () => {
                        new MetaLevelsListDialog().show();
                    }
                })
            ] : []
        });

        this._dataWithFiltersNode = NP.createNode(this._root, 'data-with-filters-container');


        this._dataTable = new DataTable({
            ParentNode: this._dataWithFiltersNode,
            ShowSettingsButton: NP.getCurrentUser().isBDAdmin(),
            Class: 'app-list--avatars mdc-data-table--margin data-table-battle',
            MultiSelect: false,
            ShowRowIndex: true,
            ImageWidth: 32,
            Columns: [{
                Content: NP.RM.getString('Tournament'),
                Width: '20%',
                PropertyContent: 'TournamentName'
            }, {
                Content: NP.RM.getString('Event'),
                PropertyContent: 'EventName',
                Width: '20%'
            }, {
                Content: NP.RM.getString('EventDate'),
                PropertyContent: 'EventDate',
                Width: '20%'
            }, {
                Content: NP.RM.getString('Status'),
                PropertyContent: 'Status',
                Width: '20%'
            }, {
                Content: NP.RM.getString('PlayersCount'),
                PropertyContent: 'PlayersCount',
                Width: '20%'
            }],
            ShowPaginator: true,
            EvSortClick: (s: DataTable, e: any) => {
                e.CanceSort = true;

                switch (e.Column) {
                    case 0:
                        this._filtersPanel.setSortValues('Tournament', e.Direction);
                        break;
                    case 1:
                        this._filtersPanel.setSortValues('Event', e.Direction);
                        break;
                    case 2:
                        this._filtersPanel.setSortValues('EventDate', e.Direction);
                        break;
                    case 3:
                        this._filtersPanel.setSortValues('Status', e.Direction);
                        break;
                }


                this._Offset = 0;

                this.refreshList();
            },
            EvPaginatorLeftClick: () => {
                this._Offset -= this._Count;
                this.refreshList();
            },
            EvItemClick: async (s: object, e: { Item: FantasyInfo }) => {
                if (NP.getCurrentUser().isBDAdmin())
                    new AddFantasyDialog({FantasyId: e.Item.Id, EvChanged: () => this.refreshList()}).show();
                else if (NP.getCurrentUser().isAdmin()) {
                    if (e.Item.Status == 'Calculated') {
                        let ratingUsers = await ServerAPI.callUiApi(`/fantasy/ratingUsers/${e.Item.Id}`) as UserRating[];
                        ratingUsers.forEach((r, idx) => r.Index = idx + 1);

                        let currentUser = ratingUsers.find(r => r.Id == NP.getCurrentUser().getKey());
                        if (currentUser)
                            this.showViewCalcDialog(e.Item.Id, currentUser);
                        else
                            NP.showMessage({RK: 'EventIsEnd'})
                    } else
                        new ChooseTeamFantasyDialog({FantasyId: e.Item.Id}).show();
                }
            },
            EvPaginatorRightClick: () => {
                this._Offset += this._Count;
                this.refreshList();
            },
            EvItemContextMenu: async (s: any, e: { Event: any, Item: FantasyInfo }) => {
                if (!NP.getCurrentUser().isBDAdmin())
                    return;

                let menu = new Menu({
                    Items: [{
                        FontImage: NP.FontImages.edit,
                        RK: 'Edit',
                        Value: 'Edit'
                    }, {
                        FontImage: NP.FontImages.user,
                        RK: 'CreateTeam',
                        Value: 'CreateTeam'
                    }, {
                        FontImage: NP.FontImages.calculation,
                        RK: 'Calculate',
                        Value: 'Calculate'
                    }, e.Item.Status == FantasyStatus.Open && {
                        FontImage: NP.FontImages.close,
                        RK: 'Close',
                        Value: 'Close'
                    }, {
                        FontImage: NP.FontImages.column,
                        RK: 'ShowGRating',
                        Value: 'ShowGRating'
                    }, {
                        FontImage: ' ',
                        Content: 'Send notification (Open Game)',
                        Value: 'PushOpenGame'
                    }, {IsSeparator: true},
                        {
                            FontImage: NP.FontImages.delete,
                            Content: 'Delete teams',
                            Value: 'DeleteAllTeams'
                        }, {
                            FontImage: NP.FontImages.delete,
                            RK: 'Delete',
                            Value: 'Delete'
                        }],
                    EvItemSelected: async (s: Menu, event: { Item: ListItem }) => {
                        switch (event.Item.getValue()) {
                            case 'CreateTeam':
                                new ChooseTeamFantasyDialog({FantasyId: e.Item.Id}).show();
                                break;
                            case 'Edit':
                                new AddFantasyDialog({
                                    FantasyId: e.Item.Id,
                                    EvChanged: () => this.refreshList()
                                }).show();
                                break;
                            case 'Calculate':
                                await ServerAPI.post(`/fantasy/calc/${e.Item.Id}`);
                                this.refreshList();
                                NP.showMessage({RK: 'Done'})
                                break;
                            case 'Close':
                                await ServerAPI.post(`/fantasy/close/${e.Item.Id}`);
                                this.refreshList();
                                NP.showMessage({RK: 'Done'})
                                break;
                            case 'ShowGRating':
                                this.showGRating(e.Item.Id);
                                break;
                            case 'Delete':
                                NP.showConfirm({
                                    RK: 'AreYouS',
                                    EvOkButtonClick: async () => {
                                        await ServerAPI.callUiApi(`/fantasy/${e.Item.Id}`, null, 'DELETE');
                                        this.refreshList();
                                    }
                                }).show();
                                break;
                            case 'DeleteAllTeams':
                                NP.showConfirm({
                                    RK: 'AreYouS',
                                    EvOkButtonClick: async () => {
                                        await ServerAPI.delet(`/fantasy/deleteAllTeams/${e.Item.Id}`);
                                        this.refreshList();
                                    }
                                }).show();
                                break;
                            case 'PushOpenGame':
                                (new Dialog({
                                    Content: [
                                        new TextField({
                                            FloatingLabel: 'Title',
                                            Value: e.Item.EventName
                                        }),
                                        new TextField({
                                            FloatingLabel: 'Body',
                                            Value: 'You still have time to make your prediction and pick fighters'
                                        })
                                    ],
                                    EvOkButtonClick: (dlg: Dialog, args: DialogCloseEventArgs) => {
                                        let c = dlg.getContent();
                                        ServerAPI.post(`/fantasy/sendNotification`, {
                                            type: 'OpenNewGame',
                                            fantasyId: e.Item.Id,
                                            body: {
                                                body: c[1].getValue(),
                                                title: c[0].getValue()
                                            }
                                        });
                                    }
                                })).show()

                                break;
                        }
                    }
                });
                menu.showContextMenu(e.Event);
            },
            EvSelectionChanged: () => {
            },
            //EvScrolled: (s: DataTable, e: any) => this._onScrolled(s, e)
        });

        this._filtersPanel = new FantasyFilterPanel({
            ParentNode: this._dataWithFiltersNode,
            Width: 280,
            EvFilterSortChanged: () => {
                this._Offset = 0;

                //this._CurrentFilter = args;
                this.refreshList();
            }
        });
    }

    applyRatingFilter(grid: DataTable, rows: UserRating[], level: number, group: number) {
        rows = rows.filter(it => {

            // if (level != null && it.Level != level)
            //     return false;

            if (group != null && it.UserGroup != group)
                return false;

            return true;
        })

        grid.setRows(rows)
    }

    convertToTSV(data) {
        // Extract keys from the first object to create the header
        const header = Object.keys(data[0]).join('\t');
        // Convert each data object to a TSV string
        const tsvRows = data.map(obj => Object.values(obj).join('\t'));
        // Combine header and rows in TSV format
        return [header, ...tsvRows].join('\n');
    }

    downloadTSV(tsvContent, fileName) {
        const blob = new Blob([tsvContent], {type: 'text/tab-separated-values;charset=utf-8;'});
        // Create link element
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = fileName;

        // Append to the document and trigger download
        document.body.appendChild(link);
        link.click();

        // Cleanup: remove the link element
        document.body.removeChild(link);
    }

    async showGRating(fId: number) {
        let ratingUsers = await ServerAPI.get<UserRating[]>(`/fantasy/ratingUsers/${fId}`);

        let groups = new Set();
        let levels = new Set();

        ratingUsers.forEach(it => {
            groups.add(it.UserGroup + '')
            levels.add(it.Level + '')
            it.UserGroup = it.UserGroup + '';
        })

        let grid: DataTable;

        let dlg = new Dialog({
            ShowHeader: true,
            Width: 700,
            Height: 700,
            Caption: NP.RM.getString('FantasyRating'),
            Content: [
                new Select({
                    Items: Array.from(groups).map(it => ({
                        Content: it,
                        Value: it
                    })),
                    Width: 100,
                    FloatingLabel: 'Group',
                    EvItemSelected: (s, e) => {
                        let group = e.Item.Value;
                        let level = dlg.getContent()[0].getValue()
                        this.applyRatingFilter(grid, ratingUsers, level, group)
                    }
                }),
                new Button({
                    Content: 'Clear',
                    EvClick: () => {
                        dlg.getContent()[0].setValue(null, false)
                        dlg.getContent()[1].setValue(null, false)
                        this.applyRatingFilter(grid, ratingUsers, null, null)
                    }
                }),
                new Button({
                    Content: 'Export',
                    EvClick: () => {

                        let data = grid.getRows().map(it => ({
                            Place: it.Place,
                            Name: it.Name,
                            Level: it.Level,
                            Points: it.CalcedPoints,
                            PTS: it.PTS
                        }))
                        // Convert data to TSV format
                        const tsvContent = this.convertToTSV(data);
                        this.downloadTSV(tsvContent, 'rating-users.tsv');

                    }
                }),
                grid = new DataTable({
                    Class: `mdc-data-table--margin`,
                    Rows: ratingUsers,
                    EvItemClick: (s: object, e: { Item: UserRating }) => {
                        this.showViewCalcDialog(fId, e.Item);
                    },
                    Columns: [{
                        Content: 'Place',
                        Width: '5%',
                        PropertyContent: 'Place'
                    }, {
                        Content: 'Username',
                        PropertyContent: 'Name',
                        Width: '55%'
                    }, {
                        Content: 'Level',
                        PropertyContent: 'Level',
                        Width: '10%'
                    }, {
                        Content: 'IsBot',
                        PropertyContent: 'IsBot',
                        Width: '10%'
                    }, {
                        Content: NP.RM.getString('Points'),
                        PropertyContent: 'CalcedPoints',
                        Width: '10%'
                    }, {
                        Content: 'PTS',
                        PropertyContent: 'PTS',
                        Width: '10%'
                    }]
                })]
        });

        dlg.show();
        dlg.getCancelButton().setIsVisible(false);

    }

    async showViewCalcDialog(fId: number, user: UserRating) {
        let response = await ServerAPI.callUiApi(`/fantasy/getBoughtFantasyOfUser/${fId}/${user.Id}`) as {
            items: FantasyRateRow[]
        };

        let rows = response.items;

        let viewRows = [] as {
            Name: string,
            Points: any,
            Id: string,
            Type: string,
            IsWin: boolean,
            CssClass: string
        }[];

        rows = rows.sort((a, b) => a.FirstName.localeCompare(b.FirstName));


        let currentAthlete: number = null;
        let labels: Label[] = []
        let userCards = await ServerAPI.get<UserCard[]>(`/cards/getUserCards/${user.Id}`)

        for (let row of rows)   //каждая строка это покупка отдельного бойца
        {
            if (currentAthlete != row.AthleteId) {
                viewRows = [];
                currentAthlete = row.AthleteId;
                labels.push(new Label({
                    Content: `<img class="photo-athlete" src="${row.PhotoUrl}"/> ${escapeHTML(row.FirstName + " " + row.LastName)}`,
                    Value: viewRows,
                    Class: 'athlete-name-label',
                    Data: row
                }));
            }

            row.AdPoints.forEach(p => {
                //выводим купленные, но не сработавшие параметры
                if (!row.WinPoints.find(wp => wp.Id == p.Id))
                    viewRows.push({
                        Id: p.Id,
                        Name: p.Name,
                        Points: 0,
                        CssClass: 'lose-row',
                        IsWin: false,
                        Type: p.Type
                    })
            });

            if (row.WinPoints && row.WinPoints.length) {
                let sumPoints = 0;
                for (let wp of row.WinPoints) {
                    let hasAd = !!row.AdPoints.find(p => p.Id == wp.Id);

                    let p = wp.Points;

                    if (hasAd && wp.Type == 'Additional2')
                        p *= 1.5;

                    let card: UserCard = null;
                    if (wp.Id == 'Win') {
                        let battle = await ServerAPI.get<IBattle>(`/battle/${row.BattleId}`)
                        card = userCards.find(card => card.name == "Athlete" && card.exCardData == battle.Winner)
                    } else {
                        card = userCards.find(card => card.fantasyPointId == wp.Key)
                    }

                    viewRows.push({
                        IsWin: true,
                        Name: wp.Name + (card ? ` (Use ${card.status} card)` : ''),
                        Points: card ? `${p} * ${card.cardCoef} * ${card.statusCoef} =${Math.round(p * card.cardCoef * card.statusCoef)}` : p,
                        Id: wp.Id,
                        Type: wp.Type,
                        CssClass: hasAd ? 'win-row' : ''
                    })

                    if (card)
                        p = p * card.cardCoef * card.statusCoef;

                    sumPoints += p;
                }

                row.Total = sumPoints;
            }
        }


        let dlg = new Dialog({
            ShowHeader: true,
            Width: 900,
            Mode: 'FullHeight',
            Caption: NP.escapeHTML(user.Name) + " = " + user.Points + ", " + NP.RM.getString("Place") + "=" + user.Index,
            Class: 'nopad fantasy-result-calc',
            Content: (labels.map(l => [l, new DataTable({
                Class: `mdc-data-table--margin`,
                Rows: l.getValue(),
                Columns: [{
                    Content: NP.RM.getString('Name'),
                    Width: '75%',
                    PropertyContent: 'Name'
                }, {
                    Content: NP.RM.getString('Points'),
                    PropertyContent: 'Points',
                    Width: '15%'
                }, {
                    Content: NP.RM.getString('Type'),
                    PropertyContent: 'Type',
                    Width: '10%'
                }]
            }),
                new Label({
                    Class: 'fantasy-grid-total',
                    Content: NP.RM.getString("Total") + " = " + Math.round(l.getData().Total)
                })]) as any).flat()
        });

        dlg.show();
        dlg.getCancelButton().setIsVisible(false);
    }


    setHeight(value: number) {
        super.setHeight(value);
        let h = this._Height - this._topAppBar.getOffsetHeight();
        this._dataTable.setHeight(h);
        this._filtersPanel.setHeight(h);
    }

    setWidth(value: number) {
        super.setWidth(value);
        this._dataTable.setWidth(value);
        if (this._dataTable.getIsSmall()) {
            this._topAppBar.removeClass('top-app-bar--no-shadow');
            this.setHeight(this._Height);
        } else {
            this._topAppBar.addClass('top-app-bar--no-shadow');
            this.setHeight(this._Height);
        }
    }

    refresh() {
        this.refreshList();
    }

    private async refreshList() {
        let fres = await ServerAPI.callUiApi("/fantasy/items", this._filtersPanel.getFilterData(), 'POST') as FantasyInfo[]

        this._dataTable.setRows(fres);
    }

    getTopAppBar() {
        return this._topAppBar;
    }
}
